module.exports = __webpack_public_path__ + "img/employee.0a6c2a6a.svg";